import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { BgxLocationModule } from '@bgx/services/location';

import { BgxNavigationService } from './navigation.service';

@NgModule({
  imports: [HttpClientModule, BgxLocationModule],
  providers: [BgxNavigationService],
})
export class BgxNavigationModule {}
